export default {
  'goldkid-FAQ:title': 'Жиі қойылатын сұрақтар',
  'goldkid-FAQ:title-answers': 'Жиі қойылатын сұрақтарға жауаптар',
  'goldkid-FAQ:question-1': 'С какого возраста я могу открыть Kaspi Gold для моего ребенка?',
  'goldkid-FAQ:answer-1': '-',
  'goldkid-FAQ:question-2': 'Какие условия и тарифы по Kaspi Gold для ребенка?',
  'goldkid-FAQ:answer-2': '-',
  'goldkid-FAQ:question-3': 'Как я могу пополнить Kaspi Gold моего ребенка?',
  'goldkid-FAQ:answer-3': '-'
}
